module.exports = fox._r("images/christmass/gift-166.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/christmass/gift-166.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/christmass/gift-166.png
// module id = 367
// module chunks = 4